import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import { ArticleTeasers as TAArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import styled from '@emotion/styled'
import { breakpoints, spacing } from '@/materials/index'

import { useEnv } from '@/lib/env'
import { Locale } from '@/domain/intl'

export const ArticleTeasers = (props: ComponentPropsWithoutRef<typeof TAArticleTeasers>) => {
  const { intl } = useEnv()

  return (
    <Root>
      <TAArticleTeasers sorting={SortMode.MANUAL} {...props} locale={intl.locale.split('-')[0] as Locale} />
    </Root>
  )
}

const Root = styled('div')`
  label: ArticleTeasers__Root;

  /**
 * Using magic numbers to adjust margin-top in order to change in the same
 * way as the child module @ta-interaktiv/react-article-teasers
 */

  grid-column: 1/-1;
  ${breakpoints.large`
    grid-column: 4 / span 7;
  `}

  ${breakpoints.mediumDown`
    & > .ui.stackable.cards {
      display: flex !important;
      overflow-x: scroll;
      flex-direction: row;
    }
  `}

  & > .ui.cards {
    flex-wrap: initial;
    flex-direction: column;
    width: 100%;
  }

  & * {
    font-family: 'Source Sans Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  }

  & a {
    color: #007abf;
    width: 100%;
  }

  & .ui.cards .ui.card.article-teaser:hover {
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  & .ui.cards .ui.card.article-teaser {
    background: none;
  }
  ${breakpoints.medium`
    & .ui.cards .ui.card.article-teaser {
      transition: border-color 0.1s ease;
      width: 100%;
      display: grid;
      padding-bottom: 10px;
      column-gap: 28px;
      grid-template-columns: repeat(8, 1fr);
      &:hover {
        transform: none;
      }
    }
  `}

  ${breakpoints.mediumDown`
    & .ui.cards .ui.card.article-teaser {
      min-width: 66% !important;
      max-width: 66% !important;
      ${spacing.mv0};
    }
  `}

  ${breakpoints.medium`
    & .ui.cards .ui.card.article-teaser .image {
      grid-column: 1 / 4;
      background: transparent;
    }
  `}

  ${breakpoints.mediumDown`
    & .ui.cards .ui.card.article-teaser .image {
      display: flex;
      width: 100%;
    }
  `}

& .ui.cards .ui.card.article-teaser .image img {
    object-fit: cover;
    aspect-ratio: 2/1;
    width: 100%;
  }

  & .ui.cards .ui.card.article-teaser .content {
    padding-top: 0;
    display: inline-block;
    grid-column: 4 / -1;
  }

  & .ui.cards .ui.card.article-teaser .content .header {
    font-family: var(--font-serif, var(--font-title));
    font-size: 24px;
    font-weight: bold;
    line-height: 27px;
    margin: 0;
    padding-top: 10px;
    color: var(--text-color);
  }
  & .ui.cards .ui.card.article-teaser .extra {
    color: var(--gray-color);
  }
  & .ui.cards .ui.card.article-teaser .content .header div {
    color: var(--blue-main);
    font-family: var(--font-sans-serif);
  }

  ${breakpoints.mediumDown`
    & .ui.cards .ui.card.article-teaser .content {
      grid-column: 4 / 9;
    }
  `}

  ${breakpoints.mediumDown`
    & .ui.cards .ui.card.article-teaser .content {
      padding: 0
    }
  `}

  & .ui.cards .ui.card.article-teaser .content .description {
    font-family: var(--font-sans-serif);
    font-family: 15px;
    line-height: 21px;
    color: var(--text-color);
  }

  ${breakpoints.mediumDown`
    & .ui.cards .ui.card.article-teaser .content .description {
      display:none
    }
  `}
`

// Export SortMode as well, so other components don't have to refer to the @ta-interaktiv package anymore
export { SortMode }
